export enum RegistrationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Declined = 'DECLINED',
}
